import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthRepository } from '@timechef/core/auth/auth.repository';
import { AuthService } from '@timechef/core/auth/auth.service';
import { LoggerService } from '@timechef/core/logging';
import { RouteData } from '@timechef/core/utils';
import { AppRepository } from '../state';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authRepository = inject(AuthRepository);
  const appRepository = inject(AppRepository);
  const authService = inject(AuthService);
  const logger = inject(LoggerService).getLogger('authGuard');
  const router = inject(Router);

  const authTokens = authRepository.getAuthTokens();
  if (!authTokens?.accessToken || !authRepository.getUser()) {
    logger.info('User not logged in -> redirect /login');
    await authService.logout({ withRedirect: true, redirectUrlAfterNextLogin: state.url });
    return false;
  }

  authService.tryRefreshTokenSilently(authTokens, `guard (${state.url})`);

  // Le compte client n'a pas été trouvé
  if (state.url != '/link-account' && authRepository.getCurrentUserSite()?.compteClientNotFound) {
    // Si l'écran nécessite un compte client ou que l'utilisateur n'a pas skip le rattachement --> redirection
    if ((route.data as RouteData)?.requiresCompteClient || !appRepository.getSkipLinkAccount()) {
      router.navigate(['/link-account']);
      return false;
    }
  }

  return true;
};
